<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading = "loading"
      :data="data"
      ref="crud"
      @on-load="onLoad"
      @refresh-change="onLoad"
      >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openAddForm('add')"
        >新  增
        </el-button>
        <el-button
          size="small"
          icon="el-icon-sort"
          :loading = "syncButtonLoading"
          @click="syncParkInfo(7)">同步
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
<!--        <el-button type="text" size="small" @click="toView(scope.row)">
          <span class="el-icon-view"></span>查看
        </el-button>-->
        <el-button type="text" size="small" icon="el-icon-edit" @click="toEdit(scope.row,'edit')">编辑</el-button>
      </template>
    </avue-crud>
    <avue-form v-if="showForm" ref="parkUserForm" v-model="form" :rules="rules" :option="option" @reset-change="emptyChange" @submit="submit">
      <template slot-scope="scope" slot="menuForm">
        <el-button @click="emptyChange" icon="el-icon-delete">清空</el-button>
      </template>
    </avue-form>
  </basic-container>
</template>

<script>
  import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/user/parkuser';
  import { syncData } from '@/api/v4ward/car/carparkspace';
  import { mapGetters } from 'vuex';

  export  default {
    props: {
      parkSpace: {},
    },
    data() {
      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          callback();
        }
      };
      const validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return{
        loading: false,
        showForm: false,
        operateType: '',
        form: {},
        syncButtonLoading: false,
        option: {
          calcHeight: 350,
          maxHeight: 200,
          tip: false,
          border: true,
          index: false,
          selection: false,
          columnBtn: false,
          viewBtn: false,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          menuType: 'text',
          refreshBtn:false,
          align: 'center',
          menuWidth: 100,
          emptyBtn: false,
          column: [
            {
              label: '登录账号',
              prop: 'account',
              editDisabled: true,
              maxlength: 32,
              rules: [
                {
                  required: true,
                  message: '请输入登录账号',
                  trigger: 'change',
                },
                { pattern: /^[a-zA-Z0-9_-]{5,10}$/, message: '格式错误' },
              ],
            },
            {
              label: '姓名',
              prop: 'username',
              maxlength: 5,
              rules: [
                {
                  required: true,
                  message: '请输入道闸客户端登录用户名称',
                  trigger: 'change',
                  pattern: this.$validation.name,
                },
              ],
            },
            {
              label: '手机号',
              prop: 'mobile',
              rules: [
                {
                  required: true,
                  message: '请输入用户手机号',
                  trigger: 'change',
                },
                {
                  required: true,
                  pattern: this.$validation.phone,
                  message: '请输入正确的手机号',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '密码',
              prop: 'password',
              type: 'password',
              rules: [
                {
                  required: true,

                  message: '密码必填',
                  trigger: 'change',
                },
                { pattern: /^[a-zA-Z]\w{5,15}$/, message: '以字母开头，包含6-16位字母和数字' },
                {
                  required: true,
                  validator: validatePass,
                  trigger: 'blur'
                },
              ],
            },
            {
              label: '确认密码',
              prop: 'password2',
              type: 'password',
              hide: true,
              viewDisplay: false,
              rules: [
                {
                  required: true,
                  validator: validatePass2,
                  trigger: 'blur'
                }
              ],
            },
            {
              label: '备注信息',
              prop: 'remark',
              type: 'textarea',
              minRows: 2,
              maxlength: 100,
              showWordLimit: true,
              overHidden: true,
            },
          ],
        },
      }
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.parkpassage_add, true),
        };
      },
      ids() {
       /* let ids = [];
        this.selectionList.forEach((ele) => {
          ids.push(ele.id);
        });
        return ids.join(',');*/
      },
    },
    created() {
      setTimeout(() =>{
        document.querySelector("#pane-parkUser > div > div > div").style='padding-top:0px !important';
        document.querySelector("#pane-parkUser > div > div > div > div.avue-crud > div.avue-crud__pagination").style='padding-top:0px !important';
      });
    },
    mounted() {},
    methods: {
      openAddForm(operateType){
        this.operateType = operateType;
        this.cleanForm();
        this.showForm = !this.showForm;
      },
      toEdit(row,operateType){
        this.operateType = operateType;
        this.showForm = !this.showForm;
        this.form = Object.assign({},row);
      },
      onLoad(){
        this.loading = true;
        getList(Object.assign({ current: null, size: 100 }, {parkingLotId: this.parkSpace.id})).then(
          ({ data }) => {
            this.data = data.records;
            this.loading = false;
          },
        );
      },
      emptyChange(){
        if(this.operateType === 'add'){
          this.cleanForm();
        }else {
          this.$message.warning('编辑时清空无效！');
        }
      },
      submit (form,done) {
        if(this.vdui.isEmpty(form.id)){
          this.form.parkingLotId = this.parkSpace.id;
          add(this.form).then(() => {
              done();
              this.$message.success('操作成功!');
              this.cleanForm();
              this.onLoad();
              this.showForm = false;
          },(error) => {
            done();
            console.log(error);
          });
        }else{
          update(this.form).then(() => {
              done();
              this.$message.success('操作成功!');
              this.cleanForm();
              this.onLoad();
              this.showForm = false;
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      },
      syncParkInfo(type) {
        this.syncButtonLoading = true;
        const  syncParam = {
          dataRange: 2,
          dataType: type,
          parkId: this.parkSpace.id,
        };
        syncData(syncParam).then(
          () => {
            this.$message.success('操作成功！');
            this.syncButtonLoading = false;
          },
          (error) => {
            window.console.log(error);
            this.syncButtonLoading = false;
          }
        );
      },
      cleanForm() {
        for(let key in this.form){
            this.form[key] = '';
        }
      },
    },



  }


</script>
<style scoped>
</style>
